import user from '@/stores/user';
import Alert from '@/utils/components/alert';
import { AddressZero } from '@ethersproject/constants';
import BigNumber from 'bignumber.js';
import { BrowserProvider, Contract, isAddress } from 'ethers';
import moment from 'moment';
import Numeral from 'numeral';
import { Token } from '../constant';
// account is not optional
// export function getSigner(
//     library: BrowserProvider,
//     account: string,
// ): Promise(JsonRpcSigner | undefined) {
//     if (library.getSigner) {
//         return library.getSigner(account);
//     } else {
//         return undefined;
//     }
// }

// export function getProviderOrSigner(
//     library: BrowserProvider,
//     account?: string,
// ): BrowserProvider | JsonRpcSigner | undefined {
//     return account ? getSigner(library, account) : library;
// }

export async function getContract(
    address: string,
    ABI: any,
    library: BrowserProvider,
    account?: string,
): Promise<Contract | null> {
    // if (!address) return null;
    if (!isAddress(address) || address === AddressZero) {
        throw Error(`Invalid 'address' parameter '${address}'.`);
    }

    try {
        const libraryOrSigner =
            account && library ? await library.getSigner(account) : library;

        return new Contract(address, ABI, libraryOrSigner);
    } catch (error) {
        console.error('Error in getContract:', error);
        return null;
    }
}

/**
 * get url vars
 */

export function getUrlVars() {
    const vars: any = {};
    let hash: string[] = [];
    const hashes = window.location.href
        .slice(window.location.href.indexOf('?') + 1)
        .split('&');

    for (let i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars[hash[0]] = hash[1];
    }

    return vars;
}

export function formatHashValue(address?: string) {
    if (!address) {
        return;
    }
    const arr = address.split('0x');
    const prev4 = arr[1].substring(0, 4);
    const last4 = arr[1].substring(arr[1].length - 4, arr[1].length);
    return `0x${prev4}...${last4}`;
}

export function fixNumberTo2(number: number) {
    const arr = number.toString().split('.');
    let len = 0;
    if (arr[1]) {
        len = Number(arr[1]) === 0 ? 0 : arr[1].length;
    }
    if (len === 0) {
        return number.toFixed(0);
    }
    return number.toFixed(2);
}

export const getBalanceNumber = (balance: BigNumber, decimals = 18) => {
    const displayBalance = balance.dividedBy(new BigNumber(10).pow(decimals));
    return displayBalance.toNumber();
};

export const getDisplayBalance = (balance: BigNumber, decimals = 18) => {
    const displayBalance = balance.dividedBy(new BigNumber(10).pow(decimals));
    if (displayBalance.lt(1)) {
        return displayBalance.toPrecision(4);
    } else {
        return displayBalance.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
};

export const getFullDisplayBalance = (
    balance: BigNumber,
    decimals = 18,
    fixed = 8,
) => {
    return balance.dividedBy(new BigNumber(10).pow(decimals)).toFixed(fixed);
};

export function shuffleArray(array: any[]) {
    // Fisher-Yates Algorithm
    const result = [...array];
    for (let index = 0; index < result.length; index++) {
        const j = Math.floor(Math.random() * index);
        const temp = result[index];
        result[index] = result[j];
        result[j] = temp;
    }
    return result;
}

export const calculateCountDown = (targetTimestamp: number) => {
    const sec = 1000;
    const min = 60 * sec;
    const hour = 60 * min;
    const timestampNow = new Date().getTime();

    const subTimestamp = targetTimestamp - timestampNow;

    if (subTimestamp <= 0) {
        return {
            h: 0,
            m: 0,
            s: 0,
            left: 0,
            format: '00:00:00',
        };
    }

    const h = Math.floor(subTimestamp / hour);
    const m = Math.floor((subTimestamp % hour) / min);
    const s = Math.floor((subTimestamp % min) / sec);

    function formatNum(num: number) {
        return num < 10 ? `0${num}` : '' + num;
    }

    return {
        h,
        m,
        s,
        left: subTimestamp,
        format: `${formatNum(h)}:${formatNum(m)}:${formatNum(s)}`,
    };
};

export const formatDate = (date: Date, fmt: string) => {
    interface FmtMap {
        [propName: string]: number;
    }

    const o: FmtMap = {
        'M+': date.getMonth() + 1, //月份
        'D+': date.getDate(), //日
        'H+': date.getHours(), //小时
        'm+': date.getMinutes(), //分
        's+': date.getSeconds(), //秒
        'q+': Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds(), //毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + '').substr(4 - RegExp.$1.length),
        );
    for (const k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(
                RegExp.$1,
                RegExp.$1.length == 1
                    ? o[k] + ''
                    : ('00' + o[k]).substr(('' + o[k]).length),
            );
        }
    }
    return fmt;
};

export function randomNum(minNum: number, maxNum: number) {
    switch (arguments.length) {
        case 1:
            return parseInt(`${Math.random() * minNum + 1}`, 10);
        case 2:
            return parseInt(
                `${Math.random() * (maxNum - minNum + 1) + minNum}`,
                10,
            );
        default:
            return 0;
    }
}

export function handlePolisError(e: any) {
    if (e) {
        let errorMessage = e.message || e.data;
        console.log(e.message);
        if (e.code === 10042) {
            errorMessage = 'Insufficient funds';
        }

        if (e.code === 1000) {
            return;
        }

        Alert({
            type: 'error',
            text:
                typeof errorMessage === 'string'
                    ? errorMessage
                    : 'Someting wrong, please try again later',
        });
    }
}

export function getTokenImg(token: Token) {
    return token.symbol.toUpperCase() === 'METIS'
        ? `https://bridge.metis.io/logo.png`
        : `https://raw.githubusercontent.com/MetisProtocol/metis-bridge-resources/master/tokens/${token.symbol.toUpperCase()}/logo.png`;
}

export function formatNumber(n: BigNumber) {
    if (n.isGreaterThan(0) && n.isLessThan(0.0001)) {
        return '< 0.0001';
    }

    return n.toFixed(4);
}

export async function copyToclipboard(text: string) {
    return navigator.clipboard.writeText(text);
}

export function formatPoints(points?: number) {
    if (points && points > 1000000) {
        return Numeral(points).format(' 0.[00]a').toUpperCase();
    }

    return Numeral(points).format('0,0.[0000]');
}

export function formatPrice(value: number | string) {
    if (Number(value) < 1e-5) return 0;
    return Numeral(value).format('0,0.[00]');
}

/**
 * 处理GraphQL错误，提取errors[0].message
 */
export const extractGraphQLErrorMessage = (err: any): string => {
    // GraphQL错误格式: {errors: [{message: 'xxx'}]}
    if ((err as any)?.response?.errors?.[0].message) {
        return (err as any)?.response?.errors?.[0].message;
    }

    if (err?.errors && Array.isArray(err.errors) && err.errors.length > 0) {
        return err.errors[0].message || 'Unknown GraphQL error';
    }
    // 如果是标准Error对象
    if (err instanceof Error) {
        return err.message;
    }
    // 其他情况返回字符串形式
    return String(err) || 'Unknown error';
};

/**
 * Generate social media share links for different platforms
 * @param url - The URL to share
 * @param text - Optional text to include with the share (default: empty string)
 * @param hashtags - Optional hashtags for Twitter (default: empty string)
 * @returns Object containing share URLs for different platforms
 */
export function getSocialShareLinks(
    url: string,
    text: string = '',
    hashtags: string = '',
) {
    const encodedUrl = encodeURIComponent(url);
    const encodedText = encodeURIComponent(text);

    return {
        twitter: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedText}`,
        telegram: `https://t.me/share/url?url=${encodedUrl}&text=${encodedText}`,
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
        linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
        reddit: `https://reddit.com/submit?url=${encodedUrl}&title=${encodedText}`,
        whatsapp: `https://api.whatsapp.com/send?text=${encodedText}%20${encodedUrl}`,
        // Medium doesn't have a direct share URL, but we can provide a generic mailto link
        email: `mailto:?subject=${encodedText}&body=${encodedText}%20${encodedUrl}`,
        // discord
    };
}

export function formatParticipant(amount: number) {
    if (amount >= 1000) {
        return '1000+';
    }

    return amount;
}

export function formatTime(time: number | string) {
    return `${moment(time)
        .utc()
        .utcOffset(-4)
        .format('MM/DD/YYYY hh:mm:ss A')} EST`;
}

export function getSelectAddress() {
    return (
        (window as any)?.web3?.currentProvider?.selectedAddress ||
        window.ethereum.selectedAddress ||
        user.address
    );
}
export const getLazbubuDataConfig = (
    lazbubuData: string,
): {
    uuid: string;
    rarity: string;
    ownerAddress: string;
    image: string;
} | null => {
    if (!lazbubuData) return null;
    try {
        // Find the first space position, JSON part is after the space
        const spaceIndex = lazbubuData.indexOf(' ');
        if (spaceIndex === -1) {
            console.error('Invalid lazbubuData format: no space found');
            return null;
        }

        // Extract JSON part
        const jsonPart = lazbubuData.substring(spaceIndex + 1);

        // Parse JSON
        const parsedData = JSON.parse(jsonPart);

        // Return uuid
        return parsedData || null;
    } catch (error) {
        console.error('Error extracting uuid from lazbubuData:', error);
        return null;
    }
};
